















































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { AuthApi } from '../../api';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		secondaryNav,
		Toast,
	},
	validations: {
		form: {
			email: { required, email },
		},
	},
	mixins: [validationMixin],
})
export default class Forgot extends Vue {
	public form = {
		email: '',
	};
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public error = null;

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const response = await new AuthApi().forgotPassword({ email: this.form.email, app: 'admin' });
		if (response.data.errors) {
			this.error = response.data.errors;
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('Password Sent', 'Successfully Sent', 'success');

		this.submitStatus = 'OK';
		setTimeout(() => {
			this.$router.push({ name: 'auth.login' });
		}, 1000);
	}
}
